export * from './api.service';
export * from './customer.service';
export * from './validator.service';
export * from './autoCompletion.service';
export * from './invoice.service';
export * from './quote.service';
export * from './search.service';
export * from './pack.service';
export * from './serv.service';
export * from './bike.service';
export * from './postit.service';
export * from './sms.service';
export * from './socket.service';
export * from './marketing.service';
export * from './letter.service';
export * from './postural.service';
export * from './bike2.service';
export * from './magasin.service';
export * from './tasks.service';
export * from './notPaid.service';
export * from './order.service';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/services/index.ts